import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

import type { GetDecisioningStudioAgentsAppGroupIdDsaIdDimensionsResult } from "./types";

export const isGetDecisioningStudioAgentsAppGroupIdDsaIdDimensionsResult = arrayOf<
  GetDecisioningStudioAgentsAppGroupIdDsaIdDimensionsResult[number]
>(
  objectOf({
    slug: string,
    name: string,
    description: string,
    updated_at: string,
    created_at: string,
  })
);
